<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <IntegradorSettingsList />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import IntegradorSettingsList from '@/components/settings/IntegradorSettingsList'

  export default {
    name: 'TestSettings',
    components: {
      PageTitle,
      PageRowWrapper,
      IntegradorSettingsList
    }
  }
</script>
